import Bus from './bus'
import { eventBus as FlatfinderBus } from '@kvass/flatfinder/src/Component.vue'

FlatfinderBus.on('onChange', function () {
  Bus.emit('flatfinder:onChange', ...arguments)
})

window.Kvass.migrate(Bus)
export default Bus
